import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import dayjs from 'dayjs';
// import Promocode from './components/promocode';
import { FetchLiveCapacity } from '../../actions/capacity';
import { SetProcessing, SetTripPassengers } from '../../actions/currentBooking';
import _filter from 'lodash/filter';
import StopsButton from '../shared/stops-button';
import ReactModal from 'react-modal';
import { CYOA_NETWORK_IDS } from '../../config';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(AdvancedFormat);

class BasketSummary extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      tripPrice:0,
      tripDiscount:0,
      tripTotal:0,
      adultPrice:0,
      adultNumber:0,
      discountPercent:0,
      showStopsModal:false,
      cyoaTotal:0,
      cyoaSubTotal:0,
      cyoaGrandTotal:0
    }

    this.onContinueClick = this.onContinueClick.bind(this);
    this.openStopsModal = this.openStopsModal.bind(this);
    this.closeStopsModal = this.closeStopsModal.bind(this);
  }

  closeStopsModal(){ this.setState({showStopsModal:false}); }
  openStopsModal(){
    this.setState({showStopsModal:true});
  }

  componentDidMount(){
    //Populate pricing details for CYOA
    if(this.props.isedit && this.props.iscyoa) this.renderCyoaPricing();
  }

  componentDidUpdate(prevProps, prevState){



    //check if calender prices avaiable and save
    if(prevProps.prices !== this.props.prices){

      if(this.props.isedit) return;

      this.setState({adultPrice: this.props.prices['price_adult']}, () => {

          let stopsOrNumAdults = 0;
          if(this.props.isedit && this.props.iscyoa) stopsOrNumAdults = this.props.itineraries.content.nr_stops * this.state.adultNumber;
          else if(this.props.iscyoa) stopsOrNumAdults = (this.props.sequenceCapacity.length !== 0) ? this.props.sequenceCapacity.nr_stops * this.state.adultNumber : "";
          else stopsOrNumAdults = this.state.adultNumber;

          const tripPrice = this.state.adultPrice * stopsOrNumAdults;

          //TODO - get product price if product
          let productPrice = 0;
          let total = tripPrice + productPrice;
          let subtotal = tripPrice;


          this.setState({
            tripPrice: tripPrice,
            tripDiscount: tripPrice * this.state.discountPercent/100,
            tripTotal: tripPrice - (tripPrice * this.state.discountPercent/100),

            cyoaTotal:total,
            cyoaSubTotal:subtotal,
            cyoaGrandTotal:subtotal - (subtotal * this.state.discountPercent/100)
          });
      });

    }



    //check passengers numbers
    if(prevProps.passengers !== this.props.passengers){

      if(this.props.isedit) return;

      let adultNum = 0;

      for(let i = 0; i < this.props.passengers.length; i++){
        if(this.props.passengers[i].age_category === 'Adult'){
          adultNum++;
        }
      }
      this.setState({ adultNumber:adultNum}, () => {

        let stopsOrNumAdults = 0;
        if(this.props.iscyoa) stopsOrNumAdults = (this.props.sequenceCapacity.length !== 0) ? this.props.sequenceCapacity.nr_stops * this.state.adultNumber : "";
        else if(this.props.isedit && this.props.iscyoa) stopsOrNumAdults = this.props.itineraries.content.nr_stops * this.state.adultNumber;
        else stopsOrNumAdults = this.state.adultNumber;

        const tripPrice = this.state.adultPrice * stopsOrNumAdults;

        //TODO - get product price if product
        let productPrice = 0;
        let total = tripPrice  + productPrice;
        let subtotal = tripPrice;


        this.setState({
          tripPrice: tripPrice,
          tripDiscount: tripPrice * this.state.discountPercent/100,
          tripTotal:tripPrice - (tripPrice * this.state.discountPercent/100),

          cyoaTotal:total,
          cyoaSubTotal:subtotal,
          cyoaGrandTotal:subtotal - (subtotal * this.state.discountPercent/100)
        });
      });
    }

    //check discounts
    if(prevProps.discount !== this.props.discount){

      //calculate discount
      if(Object.keys(this.props.discount.data).length && this.props.discount.data.bookings[0].client_bookings.length !== 0){
        const discountPrice = this.props.discount.data.bookings[0].client_bookings[0].discount;
        const originalPrice = this.props.discount.data.bookings[0].client_bookings[0].discount + this.props.discount.data.bookings[0].client_bookings[0].price;

        this.setState({discountPercent:discountPrice/originalPrice * 100 }, () => {

          let stopsOrNumAdults = 0;
          if(this.props.iscyoa) stopsOrNumAdults = (this.props.sequenceCapacity.length !== 0) ? this.props.sequenceCapacity.nr_stops * this.state.adultNumber : "";
          else if(this.props.isedit && this.props.iscyoa) stopsOrNumAdults = this.props.itineraries.content.nr_stops * this.state.adultNumber;
          else stopsOrNumAdults = this.state.adultNumber;

          const tripPrice = this.state.adultPrice * stopsOrNumAdults

          //TODO - get product price if product
          let productPrice = 0;
          let total = tripPrice  + productPrice;
          let subtotal = total;



          this.setState({
              tripDiscount: tripPrice * this.state.discountPercent/100,
              tripTotal: tripPrice - (tripPrice * this.state.discountPercent/100),

              cyoaGrandTotal:subtotal - (subtotal * this.state.discountPercent/100)
          });
        });
      }

      //reset discount
      if(Object.keys(this.props.discount.data).length === 0 && !this.props.discount.valid){
        this.setState({discountPercent: 0});
      }


    }


    //Update pricing for Edit view
    if(prevProps.bookingGroup !== this.props.bookingGroup){
      if(this.props.iscyoa){
        this.renderCyoaPricing();
      }
    }

    if(prevProps.itineraries !== this.props.itineraries){
      if(this.props.isedit){
        this.renderCyoaPricing();
      }
    }

  }

  renderCyoaPricing(){



    const _adultPrice = this.props.isedit ? this.props.itineraries.sectors[this.props.itineraries.sectors.length -1].transfer.price : this.props.bookingGroup.trips[0].passengers[0].reservations[0].price;
    const _adultNumber = this.props.isedit ? this.props.itineraries.content.nr_pax : this.props.bookingGroup.passengers.length;
    const _bookingOrEdit = this.props.isedit ? _filter(this.props.itineraries.trips, item => item.tour_id !== "UH3").map(item => { return { name:item.name, price:item.passengers[0].price}}) : _filter(this.props.bookingGroup.trips, item => item.tour_id !== "UH3").map(item => { return { name:item.tour_name, price:item.passengers[0].reservations[0].price}});


    this.setState({adultPrice:_adultPrice, adultNumber:_adultNumber}, () => {

      const tripPrice = this.state.adultPrice * this.props.itineraries.content.nr_stops;
      const products = _bookingOrEdit;
      let productPrice = 0;

      for(let i = 0; i < products.length; i++){
        productPrice += parseInt(products[i].price, 10);
      }
      let total = tripPrice + productPrice;
      let subtotal = total * this.state.adultNumber;

      this.setState({
        cyoaTotal:total,
        cyoaSubTotal:subtotal,
        cyoaGrandTotal:subtotal - (subtotal * this.state.discountPercent/100),
        tripDiscount: subtotal * this.state.discountPercent/100
      });


    });
  }

  renderDate(dates, duration){
    if(duration == null){
      return (dates === "") ? "No date selected" : dayjs(dates).format("Do MMMM YYYY");
    }else{
      return (duration === null || dates === "") ? "No date selected" : dayjs(dates).add(duration, 'days').format("Do MMMM YYYY");
    }
  }

  renderTime(time, dates){
    if(time !== undefined && dates !== "") return "at " + time.substring(0, time.lastIndexOf(":"));
  }

  renderLocation(location){
    if(location !== undefined) return "at " + location;
  }

  renderCity(locationArr, city){
    if(locationArr !== undefined){
        if(city === 'start' ){
          return ', ' + locationArr[0].name;
        }else{
          return', ' + locationArr[1].name;
        }
    }
  }

  renderExceptionMsg(dates, tourId){
    if(dates !== "" && tourId === "BOG"){
      return <span className="exception-txt"><br/>(End times vary depending on ferries. We strongly recommend booking onward travel for after 12pm the day following arrival back to Athens as the return ferry times can often vary and may be subject to delays.)</span>
    }
  }

  renderPaxDetail(paxType, currencySign, props){

    let stopsOrNumAdults = 0;
    if(props.isedit && props.iscyoa) { stopsOrNumAdults = this.props.itineraries.content.nr_stops; }
    else if(props.iscyoa) { stopsOrNumAdults = (props.sequenceCapacity.length !== 0) ? props.sequenceCapacity.nr_stops : ""; }
    else { stopsOrNumAdults = this.state.adultNumber; }

    const _adultPrice = (this.state.adultPrice === 0 || this.state.adultNumber === 0) ? " " : currencySign + this.state.adultPrice + " x " + stopsOrNumAdults + " =";
    const _adultTotalPrice = (this.state.adultPrice === 0) ? currencySign + "0.00" : " " + currencySign + this.state.adultPrice * stopsOrNumAdults;

    if((paxType === 'adult' && props.currentBooking.departure_date !== "") || (props.isedit && props.iscyoa) ) return _adultPrice + _adultTotalPrice;
  }

  renderStandardOrCyoaCapacity(props){

    const capacityDuration = (props.capacity.length !== 0 ) ? props.capacity.header.duration : "";
    const sequenceCapacityDuration = (props.sequenceCapacity.length !== 0) ? props.sequenceCapacity.min_days : "";

    if(!props.isedit){
      return (props.iscyoa) ? sequenceCapacityDuration : capacityDuration;
    }else{
      return props.itineraries.content.nr_days;
    }

  }

  renderCyaoStopsCity(props){

    // Load number of cities from sequence capacity (basket) or booking response (edit trips)
    let cities, stops;
    if(!props.isedit){
      cities = (props.sequenceCapacity.length !== 0) ? props.sequenceCapacity.nr_cities : "";
      stops = (props.sequenceCapacity.length !== 0) ? props.sequenceCapacity.nr_stops : "";
    }else{
      cities = props.itineraries.content.nr_cities;
      stops = props.itineraries.content.nr_stops;
    }


    if(props.iscyoa){
      return (
        <Fragment>
          <div className="column small-7">
            <p className="title no-margin">

            <svg width="17" height="21" viewBox="0 0 17 21" xmlns="http://www.w3.org/2000/svg" className="city-svg">
              <g fill="none" fillRule="evenodd">
                <path d="M8.34 3.97a3.46 3.46 0 1 0 0 6.92 3.46 3.46 0 0 0 0-6.92m0 8.02a4.57 4.57 0 1 1 0-9.13 4.57 4.57 0 0 1 0 9.13" fill="#F60"/>
                <path d="M8.34 5.98a1.45 1.45 0 1 0 0 2.9 1.45 1.45 0 0 0 0-2.9m0 4a2.56 2.56 0 1 1 0-5.12 2.56 2.56 0 0 1 0 5.12" fill="#F60"/>
                <g>
                  <path d="M11.24 18a.55.55 0 0 1-.45-.88c1.03-1.42 3.8-5.37 4.25-6.54.35-.9.53-1.69.53-2.35a7.2 7.2 0 0 0-2.11-5.28A6.85 6.85 0 0 0 8.31 1.1a6.84 6.84 0 0 0-5.1 1.84 7.19 7.19 0 0 0-2.1 5.28c0 .57.12 1.23.38 1.97.43 1.25 3.55 5.4 4.7 6.9a.55.55 0 0 1-.86.68C4.89 17.2 1 12.2.44 10.56A7.28 7.28 0 0 1 0 8.23c0-2.41.87-4.57 2.45-6.08A7.94 7.94 0 0 1 8.34 0c2.25-.1 4.34.66 5.88 2.14a8.28 8.28 0 0 1 2.45 6.08c0 .8-.2 1.73-.6 2.75-.6 1.54-4.23 6.57-4.38 6.78a.55.55 0 0 1-.45.23" fill="#F60" mask="url(#b)"/>
                </g>
                <g transform="translate(6 18)">
                  <path d="M2.34 3a.55.55 0 0 1-.4-.16L.71 1.6A.55.55 0 1 1 1.5.83l.84.84.84-.84a.55.55 0 1 1 .78.78L2.73 2.84c-.11.1-.25.16-.4.16" fill="#F60" mask="url(#d)"/>
                </g>
              </g>
            </svg>

            Destinations
            </p>
          </div>
          <div className="column small-5">
            <p className="no-margin text-right">{cities} cities</p>
          </div>

          <hr />

          <div className="column small-7">
            <p className="title no-margin">
              <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" className="coach-svg">
                <g fill="#F60" fillRule="nonzero">
                  <path d="M9.5 16.2a43 43 0 0 1-5.2-.3c-1-.1-1.6-.9-1.6-1.8v-10C2.7 2 4.6 0 6.9 0H12c2.3 0 4.2 1.9 4.2 4.2v10c0 .8-.7 1.6-1.6 1.7a43 43 0 0 1-5.1.3zM6.9 1a3.2 3.2 0 0 0-3.2 3.2v10c0 .3.3.7.7.7a42 42 0 0 0 10.1 0c.4 0 .7-.4.7-.8v-10C15.2 2.5 13.8 1 12 1H7z"/>
                  <path d="M3.2 3.6c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h12.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5H3.2zM15.7 9.9H3.2c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h12.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5zM6.8 18h-1c-.7 0-1.3-.5-1.3-1v-1.3c0-.1 0-.2.2-.3l.3-.1 2.6.2c.3 0 .5.2.5.4v1c0 .6-.6 1.1-1.3 1.1zm-1.3-1.8v.7c0 .2.2.3.3.3h1c.1 0 .3-.1.3-.3v-.6l-1.6-.1zM13 18h-.9c-.7 0-1.3-.6-1.3-1.4v-1.4c0-.2.2-.5.5-.5l2.5-.3.4.1.2.4v1.7c0 .8-.6 1.4-1.3 1.4zm-1.2-2.3v.9c0 .2.2.3.3.3h1c.1 0 .3-.1.3-.3v-1l-1.6.1zM11.2 11.7H7.7c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h3.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5zM11.2 13.5H7.7c-.3 0-.5-.2-.5-.4 0-.3.2-.5.5-.5h3.5c.3 0 .5.2.5.5 0 .2-.2.4-.5.4zM11.2 2.7H7.7c-.3 0-.5-.2-.5-.5 0-.2.2-.4.5-.4h3.5c.3 0 .5.2.5.4 0 .3-.2.5-.5.5z"/>
                  <path d="M17.5 5.4a.5.5 0 0 1-.5-.5 1 1 0 0 0-.4-.8c-.7-.5-1.6-.4-1.6-.4a.5.5 0 0 1-.6-.4c0-.3.2-.5.4-.6.1 0 1.4-.2 2.4.6.5.4.8 1 .8 1.6 0 .3-.2.5-.5.5z"/>
                  <path d="M17.6 8.1h-.5c-.5 0-.9-.6-.9-1.3V5c0-.3.2-.5.4-.5h1c.2 0 .4.2.4.5v2.6c0 .3-.2.5-.4.5zM17 5.6v1.2l.1.2h.1V5.6H17zM.5 5.4a.5.5 0 0 1-.5-.5c0-.6.3-1.2.8-1.6 1-.8 2.3-.6 2.4-.6.2 0 .4.3.4.6s-.3.5-.6.5c0 0-1-.2-1.6.3A1 1 0 0 0 1 5c0 .3-.2.5-.5.5z"/>
                  <path d="M.9 8.1H.4c-.2 0-.4-.2-.4-.5V5c0-.3.2-.5.4-.5h1c.2 0 .4.2.4.5v1.8c0 .7-.4 1.3-1 1.3zm-.1-1l.2-.3V5.6H.8V7zM5 13.5H3.2c-.3 0-.5-.2-.5-.5v-1.7c0-.3.2-.5.5-.5H5c.7 0 1.3.5 1.3 1v.6c0 .6-.6 1.1-1.3 1.1zm-1.2-1h1.4v-.6c0-.1 0-.2-.2-.2H3.8v.9zM15.7 13.5h-1.8c-.7 0-1.3-.5-1.3-1v-.6c0-.6.6-1.1 1.3-1.1h1.8c.3 0 .5.2.5.5V13c0 .2 0 .3-.2.4l-.3.1zm-1.8-1.8c-.1 0-.2 0-.2.2v.5c0 .1 0 .2.2.2H15v-.9H14zM12.2 8.1a.5.5 0 1 1 0-1h1.1V5.8a.5.5 0 0 1 1.1 0v1.7c0 .2-.2.5-.5.5h-1.7z"/>
                </g>
              </svg>
              Coach trips
            </p>
          </div>
          <div className="column small-5">
            <p className="no-margin text-right">{stops} stops</p>
          </div>

          <hr />
        </Fragment>
      )
    }else{
      return null;
    }
  }

  renderStandardOrCyoaStartEnd(props){

    let sequenceCapacityDuration = 1;

    if(props.sequenceCapacity.length !== 0){
      for(let i = 0; i < props.sequenceCapacity.sequence.length; i++){
        sequenceCapacityDuration += props.sequenceCapacity.sequence[i].duration;
      }
    }


    const basketOrEdit = {
      "start_city": (!props.isedit) ? props.sequenceCapacity.start_city : props.itineraries.sectors[0].city,
      "end_city": (!props.isedit) ? props.sequenceCapacity.end_city : props.itineraries.sectors[props.itineraries.sectors.length - 1].city,
      "start_date": (!props.isedit) ? props.currentBooking.departure_date : props.itineraries.content.date_start,
      "duration": (!props.isedit) ? sequenceCapacityDuration : props.itineraries.content.nr_days,
      "start_address": (!props.isedit) ? props.cities : props.itineraries.cities,
      "end_address": (!props.isedit) ? props.cities : props.itineraries.cities,
    }


    return (
      <ul>
        <li>
          <p className="no-margin">{basketOrEdit.start_city}</p>
          <p className="subtext no-margin"><span className="orange-text bold">Start:</span> {this.renderDate(basketOrEdit.start_date, null)} </p>
          <p className="subtext small-text no-margin">{(_filter(basketOrEdit.start_address,['name', basketOrEdit.start_city])[0] !== undefined && _filter(basketOrEdit.start_address,['name', basketOrEdit.start_city])[0].address !== null) ? _filter(basketOrEdit.start_address,['name', basketOrEdit.start_city])[0].address.replace("__", "").replace("__", " -") : ""}</p>
             <StopsButton stops={!props.isedit ? props.sequenceCapacity.nr_stops : props.itineraries.content.nr_stops } stopsClicked={()=>this.openStopsModal()}/>
        </li>

        <li>
          <p className="no-margin">{basketOrEdit.end_city}</p>
          <p className="subtext no-margin"><span className="orange-text bold">End:</span> {this.renderDate(basketOrEdit.start_date, basketOrEdit.duration) }</p>
          <p className="subtext small-text no-margin">{(_filter(basketOrEdit.end_address,['name', basketOrEdit.end_city])[0] !== undefined && _filter(basketOrEdit.end_address,['name', basketOrEdit.end_city])[0].address !== null) ? _filter(basketOrEdit.end_address,['name', basketOrEdit.end_city])[0].address.replace("__", "").replace("__", " -") : ""}</p>
        </li>
      </ul>
    )
  }

  onContinueClick(){


    const {
      basketType,
      onContinue,
      SetProcessing,
      currency:{ iso_currency_code },
      FetchLiveCapacity,
      currentBooking:{tour_id, city_id, departure_date},
      sequenceCapacity:{sequence},
      iscyoa,
      SetTripPassengers,
      passengers,
      capacity:{header},
      isedit,
      prices
     } = this.props;


    //open depart modal - standalone
    if(basketType === "" || basketType ==="basket"){
        onContinue();
    }else{

        if(isedit){
          this.props.closeEdit();
        }else{

          //Set processing preloader
          SetProcessing(true);

          //Set passengers paylaod with reservations for cyoa tours or hohotour
          if(iscyoa || header.type === 'hoho') SetTripPassengers(passengers, sequence, departure_date, prices['price_adult']);

          //check live capacity
          FetchLiveCapacity(
            tour_id,
            iso_currency_code,
            city_id,
            dayjs(departure_date).format("YYYY"),
            dayjs(departure_date).format("MM"),
            dayjs(departure_date).format("DD")
          );

        }
    }

  }


  renderStopsModal(props){

    if(props.iscyoa){
      let _stopCities;
      let _stopCitiesNumber;
      if(props.isedit){
        _stopCities = props.itineraries.sectors.map(item => item.name);
      }else{
        _stopCitiesNumber = (props.sequenceCapacity.sequence !== undefined) ? props.sequenceCapacity.sequence.length : [];
        _stopCities = (props.sequenceCapacity.sequence !== undefined) ? props.sequenceCapacity.sequence : [];
      }

      return (
        <ReactModal
          className="include-modal"
          overlayClassName="modal-overlay semi-white"
          isOpen={this.state.showStopsModal}
          onRequestClose={this.closeStopsModal}
          contentLabel="Stops modal">

           <div className="row">
             <div className="column small-12 stops-vertical">
               <ul>
               {
                 _stopCities.map((list, i) => {
                  let name = !props.isedit ? list.city : list;
                  let days = list.duration===1 ? ' day' : ' days';
                  let duration = !props.isedit ?
                      list.duration
                      ? list.duration + days
                      : ''
                  : '';
                  let label = !props.isedit
                    ? !list.duration
                      ? _stopCitiesNumber === i+1
                        ? 'End'
                        : 'Start'
                      : ''
                  : '';
                  return <li className={`${(list.type === 'product') ? "fixed-product": ""}`} key={i}>
                      <p className="no-margin">{name}</p>
                      <p className="subtext no-margin">
                        <span className={`orange-text ${label === "" ? "hide" : ""}`}>{label}</span>{duration}
                      </p>
                   </li>
                 })
               }
               </ul>
             </div>

             <div className="column small-12">
               <button className="modal-close orange" onClick={this.closeStopsModal}>
                 &#x2715;
               </button>
             </div>
           </div>
        </ReactModal>
      )
    }else{
      return null;
    }
  }

  renderStandardOrCyoaTravellers(props, currencySign, iso_currency_code){

    if(!props.iscyoa){
      return (
        <Fragment>
          <div className="column small-12">
            <p className="title">

            <svg xmlns="http://www.w3.org/2000/svg" width="75.315" height="67.558" viewBox="0 0 75 67" className="traveller-svg">
              <g data-name="Layer 2">
                <g data-name="Layer 1">
                  <path d="M31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                  <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                  <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                  <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42zM31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                  <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                  <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                  <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42z"/>
                </g>
              </g>
            </svg>

            Travellers

            </p>
          </div>

           <div className="column small-12 clearfix">
            <p className="no-margin">{this.state.adultNumber + ' Adults'}
              <span className="float-right">{this.renderPaxDetail('adult', currencySign, this.props)}</span>
            </p>
          </div>

        </Fragment>
      )
    }else{

      // Load number of cities from sequence capacity (basket) or booking response (edit trips)
      let tripDetails, total, subtotal, accomodationText, cyoPrice;
      if(!props.isedit){
        tripDetails = [];
        total = this.state.cyoaTotal.toFixed(2);
        subtotal = this.state.cyoaSubTotal.toFixed(2);
        accomodationText = "";
        cyoPrice = "";
      }else{
        tripDetails = _filter(props.itineraries.trips, item => (item.tour_id !== CYOA_NETWORK_IDS["europe"].id && item.tour_id !== CYOA_NETWORK_IDS["usa"].id)).map(item => { return { name:item.name, price:parseInt(item.passengers[0].price, 10)}});
        total = props.itineraries !== undefined ? (parseFloat(props.itineraries.grand_total)/props.itineraries.content.nr_pax).toFixed(2) : "";
        subtotal = (props.itineraries !== undefined) ? props.itineraries.grand_total : "";
        accomodationText = props.itineraries !== undefined ? props.itineraries.trips[0].descriptions[1] : "";
        cyoPrice = props.itineraries !== undefined ? (parseFloat(props.itineraries.trips[0].passengers[0].price) + parseFloat(props.itineraries.trips[0].passengers[0].accomm_price) - parseFloat(props.itineraries.trips[0].passengers[0].discount)).toFixed(2) : "";
      }


      return (
        <Fragment>
          <div className="column small-7">
            <p className="title no-margin">

            <svg xmlns="http://www.w3.org/2000/svg" width="75.315" height="67.558" viewBox="0 0 75 67" className="traveller-svg">
              <g data-name="Layer 2">
                <g data-name="Layer 1">
                  <path d="M31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                  <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                  <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                  <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42zM31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                  <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                  <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                  <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42z"/>
                </g>
              </g>
            </svg>

            Travellers
            </p>
          </div>
          <div className="column small-5">
            <p className="no-margin text-right">
              {this.state.adultNumber + ' Adults'}
            </p>
          </div>

          <span style={{display: (props.currentBooking.departure_date !== "" || props.isedit) ? 'block':'none'}}>

            <div className={`column small-12 ${(!props.isedit) ? 'hide' : ''}`}>
              <hr style={{paddingTop: 0}} />
              <div className="row no-padding">
                <div className="column small-7">
                  <p className="no-margin bold">{props.itineraries !== undefined ? `${props.itineraries.sectors[0].name} to ${props.itineraries.sectors[props.itineraries.sectors.length-1].name}` : ""  }</p>
                  <p className="no-margin">{props.itineraries !== undefined ? props.itineraries.trips[0].descriptions[0] : "" }</p>
                  <p className="no-margin" style={{display:(props.itineraries !== undefined && props.itineraries.accomm_total !== "0.00") && props.isedit ? "block" : "none"}}>{accomodationText}</p>
                </div>
                <div className="column small-5">
                  <p className="no-margin text-right">
                    {`${currencySign}${cyoPrice}`} {iso_currency_code}
                  </p>
                </div>
              </div>
              <div className="row no-padding margin-b-10">
                {
                  tripDetails.map((item, i) => {
                    return(
                      <Fragment key={i}>
                        <div className="column small-8"><p className="no-margin bold">{item.name}</p></div>
                        <div className="column small-4"><p className="no-margin text-right">{`${currencySign}${item.price.toFixed(2)}`} {iso_currency_code}</p></div>
                      </Fragment>
                    )
                  })
                }
              </div>
              <div className="row no-padding">
                <div className="column small-6"><p className="no-margin">Trip Total:</p></div>
                <div className="column small-6"><p className="no-margin text-right">{`${currencySign}${total}`} {iso_currency_code}</p></div>
              </div>
              <div className="row no-padding margin-b-10">
                <div className="column small-6"><p className="bold no-margin">Subtotal {`(x ${this.state.adultNumber} Adults):`}</p></div>
                <div className="column small-6"><p className="no-margin text-right bold">{`${currencySign}${subtotal}`} {iso_currency_code}</p></div>
              </div>
            </div>

          </span>

        </Fragment>
      )
    }
  }


  renderStandardOrCyoaTotalBox(props, currencySign, iso_currency_code){

    //Cyoa button
    /*if(!props.isedit && props.iscyoa){
      return (
        <Fragment>
          <Row className="total-section" style={{display: (props.currentBooking.departure_date !== "") ? 'block':'none'}}>
            <Column small={6} className="bold">Total price</Column>
            <Column small={6} className="text-right bold orange-text">{ `${currencySign ? currencySign : props.bookingGroup.currency_sign}` + this.state.cyoaGrandTotal.toFixed(2) }</Column>
          </Row>
        </Fragment>
      )
    }*/

    let grandTotal;


    if(!props.isedit){
      grandTotal = this.state.cyoaGrandTotal.toFixed(2);
    }else{
      grandTotal = props.itineraries.grand_total;

    }

    //Edit button
    if(props.isedit && props.iscyoa){
      return (
        <Fragment>
          <div className="row total-section">
            <div className="column small-7 bold">Total Price:</div>
            <div className="column small-5 text-right bold orange-text">{ `${currencySign ? currencySign : props.bookingGroup.currency_sign}` + grandTotal } {iso_currency_code}</div>
          </div>
        </Fragment>
      )
    }

  }


  renderStandardOrCyoaOrEditButton(props){

    //Cyoa button
    if(!props.isedit && props.iscyoa){
      return (
        <button
          type="submit"
          className={`continue-btn busabout--cta orange ${(props.tour_id !== "" && props.currentBooking.departure_date !== "" && props.passengers.length > 0 && !props.sequenceCapacityLoading) ? '': 'disabled'}` }
          disabled={ (props.tour_id !== "" && props.currentBooking.departure_date !== "" && props.passengers.length > 0 && !props.sequenceCapacityLoading) ? false : true}
          onClick={this.onContinueClick}>
          Let's Go
        </button>
      )
    }

    //Edit button
    if(props.isedit && props.iscyoa){
      return (
        <button
          type="submit"
          className="continue-btn busabout--cta orange"
          onClick={this.onContinueClick}>
          Finish Editing
        </button>
      )
    }


  }

  render(){

    const { tripDiscount, discountPercent } = this.state;
    const { basketsummaryclass, currency:{currency_mask, iso_currency_code},  discount, productType } = this.props;
    const currencySign = (currency_mask !== undefined) ? currency_mask.charAt(0) : "";


    return (
      <React.Fragment>
        <div className={`basketsummary ${basketsummaryclass}`}>

          <div className="summary-box">

            <div className="row title">
              <div className="column small-12">
                <h5 className="busabout-h5">Booking Summary</h5>
              </div>
            </div>

            <div className="row">

              <span style={{'display':(productType === 'hoho') ? 'none' : 'block'}}>

                {this.renderStandardOrCyoaStartEnd(this.props)}

                <hr />

                <div className="column small-7">
                  <p className="title no-margin">
                  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" className="duration-svg">
                    <g fill="none" fillRule="evenodd">
                      <path d="M11.7 10.4H9.85a.52.52 0 0 1-.52-.52V8.02a.52.52 0 0 1 1.04 0v1.34h1.35a.52.52 0 1 1 0 1.04" fill="#F60"/>
                      <g transform="translate(0 -.24)">
                        <path d="M9.85 1.33a8.81 8.81 0 0 0-8.81 8.8 8.81 8.81 0 0 0 17.63 0c0-4.86-3.96-8.8-8.82-8.8m0 18.62A9.85 9.85 0 0 1 0 10.12a9.85 9.85 0 0 1 19.7 0 9.85 9.85 0 0 1-9.85 9.83" fill="#F60" mask="url(#b)"/>
                      </g>
                      <path d="M9.85 2.95A6.95 6.95 0 0 0 2.9 9.88a6.95 6.95 0 0 0 13.9 0 6.95 6.95 0 0 0-6.95-6.93m0 14.9a7.98 7.98 0 0 1-7.98-7.97 7.98 7.98 0 0 1 15.97 0c0 4.39-3.58 7.96-7.99 7.96" fill="#F60"/>
                      <path d="M9.72 4.83a.52.52 0 0 1-.52-.51V2.46a.52.52 0 0 1 1.04 0v1.86c0 .28-.24.51-.52.51M4.28 10.26H2.4a.52.52 0 1 1 0-1.03h1.87a.52.52 0 1 1 0 1.03M9.72 17.55a.52.52 0 0 1-.52-.52v-1.86a.52.52 0 0 1 1.04 0v1.86c0 .29-.24.52-.52.52M17.02 10.26h-1.86a.52.52 0 1 1 0-1.03h1.86a.52.52 0 1 1 0 1.03" fill="#F60"/>
                    </g>
                  </svg>
                  Duration
                  </p>
                </div>

                <div className="column small-5">
                  <p className="no-margin text-right"> { this.renderStandardOrCyoaCapacity(this.props) } days</p>
                </div>

                  <hr/>

                  { this.renderCyaoStopsCity(this.props) }

              </span>

              { this.renderStandardOrCyoaTravellers(this.props, currencySign, iso_currency_code) }


              <div className="column small-12" style={{display:(discount.valid) ? 'block' : 'none' }}>
                <p className="discount-text no-margin-bottom">{discountPercent + "% Discount"}
                  <span className="float-right">{`- ${currencySign ? currencySign : this.props.bookingGroup.currency_sign}` + tripDiscount.toFixed(2) }</span>
                </p>
              </div>

              {/*<Column small={12}>
                <Promocode basketType={this.props.basketType} />
              </Column>*/}


            </div>

            {this.renderStandardOrCyoaTotalBox(this.props, currencySign, iso_currency_code)}

          </div>

          <div className="row title">
            <div className="column small-12">
              {this.renderStandardOrCyoaOrEditButton(this.props)}
          </div>
        </div>

        </div>

        { this.renderStopsModal(this.props) }

      </React.Fragment>
    )
  }
}

function mapStateToProps(state){
  return{
    currency:state.currency,
    processing:state.currentBooking.processing,
    currentBooking:state.currentBooking.trips[0],
    discount:state.discount,
    prices:state.currentBooking.prices,
    passengers:state.currentBooking.passengers,
    product:state.product.content,
    productType:state.product.header.type,
    capacity:state.capacity.data,
    sequenceCapacity:state.sequenceCapacity.data,
    cities:state.cities.data,
    bookingGroup:state.bookingGroup.data,
    sequenceCapacityLoading:state.sequenceCapacity.isFetching,
    itineraries:state.itineraries.data,
    hasAccomodation:state.currentBooking.accommodation
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchLiveCapacity,
    SetProcessing,
    SetTripPassengers
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(BasketSummary);



// WEBPACK FOOTER //
// ./src/components/departure/basketsummary.js